(function () {
  function initSalazonarteAboutReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.salz-about__reveal:not(.in)');

    if (!items.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('in');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  initSalazonarteAboutReveal(document);

  document.addEventListener('shopify:section:load', function (event) {
    initSalazonarteAboutReveal(event.target);
  });
}());
